export function isNumber(value) {
  return /^\d+$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/validate/number.js
// module id = null
// module chunks = 